var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 30,
        "min-height": 50,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title is-flex-items-center" }, [
          _c("span", [_vm._v("New Batch")]),
        ]),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", { staticClass: "column is-full-mobile is-half-tablet" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Average Cost Target"),
              ]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0, symbol: "$", precision: 2 },
                    model: {
                      value: _vm.value.agreedArc,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "agreedArc", $$v)
                      },
                      expression: "value.agreedArc",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "column is-full-mobile is-half-tablet" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Min Batch Size")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0 },
                    model: {
                      value: _vm.value.minBatchSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "minBatchSize", $$v)
                      },
                      expression: "value.minBatchSize",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", { staticClass: "column is-full-mobile is-half-tablet" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Total Value (ex GST)"),
              ]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0, symbol: "$", precision: 2 },
                    model: {
                      value: _vm.value.perQuoteTotalMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "perQuoteTotalMin", $$v)
                      },
                      expression: "value.perQuoteTotalMin",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "column is-full-mobile is-half-tablet" }, [
              _c("label", { staticClass: "label" }, [_vm._v("to")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0, symbol: "$", precision: 2 },
                    model: {
                      value: _vm.value.perQuoteTotalMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "perQuoteTotalMax", $$v)
                      },
                      expression: "value.perQuoteTotalMax",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", { staticClass: "column is-full-mobile is-half-tablet" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("ALR Lower Threshold"),
              ]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0, symbol: "$", precision: 2 },
                    model: {
                      value: _vm.value.alrLowerThreshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "alrLowerThreshold", $$v)
                      },
                      expression: "value.alrLowerThreshold",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "column is-full-mobile is-half-tablet" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("ALR Upper Threshold"),
              ]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0, symbol: "$", precision: 2 },
                    model: {
                      value: _vm.value.alrUpperThreshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "alrUpperThreshold", $$v)
                      },
                      expression: "value.alrUpperThreshold",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot is-flex is-justify-content-flex-end" },
        [
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "button is-success tooltip",
                attrs: { "data-tooltip": "Save" },
                on: { click: _vm.add },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-plus mdi-20px" }),
                ]),
                _c("span", [_vm._v("Add")]),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Close" },
                on: { click: _vm.close },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-close mdi-20px" }),
                ]),
                _c("span", [_vm._v("Close")]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }